module.exports = __webpack_public_path__ + "img/register-front.9516813d.png";